import Page from '../../classes/Page'
import { app } from '../../utils/store'
import { MAPS_STYLE } from '../../utils/map'

import Maps from '../../modules/Maps.bak'

export default class SingleStore extends Page {
    constructor() {
        super({
            id: 'single_store',
            element: '[data-app-page]',
            elements: {
                map: '#map',
            }
        })
    }

    create() {
        super.create()

        if (this.elements.map) {
            this.coordinates = this.elements.map.getAttribute('coordinates')

            this.map = new Maps({
                styles: MAPS_STYLE,
                element: this.elements.map,
                zoom: {
                    value: 13,
                    controls: {
                        enable: false,
                        // options: {
                        //     style: google.maps.ZoomControlStyle.SMALL,
                        //     position: google.maps.ControlPosition.RIGHT_TOP,
                        // }
                    }
                },
                coordinates: {
                    lat: Number(this.coordinates.split(',')[0]),
                    lng: Number(this.coordinates.split(',')[1])
                },
                ui: false,
                wheel: false,
                fullscreen: false,
                streetView: false,
                mapTypeControl: false,
                draggable: false
            })

            var marker = document.createElement('article')
            marker.setAttribute('data-kind', 'febal-casa-store');
            marker.setAttribute('data-title', '');
            marker.setAttribute('data-id', '');
            marker.setAttribute('data-lat', Number(this.coordinates.split(',')[0]));
            marker.setAttribute('data-lng', Number(this.coordinates.split(',')[1]));
            console.log(marker);

            let markersList = [marker];


            this.map.create({search: null, markers: null, markersList: markersList, single: true})
        }
    }

    addEventListeners() {

    }

    destroy() {
        super.destroy()
    }
}